<div class="app__view">
  <app-header class="app__header"
              [class.app__header--fixed]="wasPageScrolled"
              [class.app__header--transparent]="isStartPage && !wasPageScrolled"></app-header>
  <div id="headerContainer"
       *ngIf="!isStartPage"
       [style.background-image]="headerService.headerBackground">
    <app-header-context></app-header-context>
  </div>
  <router-outlet></router-outlet>
  <app-footer class="app__footer"></app-footer>
</div>
